export default __webpack_public_path__ + "static/05-6d0625be1781b49178f0b8566080c047.gif";